import React from 'react';
import HeaderProfile from '../Components/HeaderProfile'

const Myprofile = () => (
    <>
        <HeaderProfile></HeaderProfile>
        <div className="toolbar py-2" id="kt_toolbar">
            <div id="kt_toolbar_container" className="container-fluid d-flex align-items-center">
                <div className="flex-grow-1 flex-shrink-0 me-5">
                    <div data-kt-swapper="true" data-kt-swapper-mode="prepend" data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}" className="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0">
                        <h1 className="d-flex align-items-center text-gray-900 fw-bold my-1 fs-3">Settings</h1>
                        <span className="h-20px border-gray-200 border-start mx-3"></span>
                        <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-1">
                            <li className="breadcrumb-item">
                                <a href="/Settings/Myprofile" className="text-muted text-hover-primary">My Profile</a>
                            </li>

                        </ul>
                    </div>
                </div>
                <div class="d-flex align-items-center flex-wrap">


                    <div class="flex-shrink-0 me-2 d-none-mob">
                        <ul class="nav" role="tablist">
                            <li class="nav-item" role="presentation">
                                <a href='/settings'>
                                    <img src='/assets/images/back.png' width={30} /> </a>
                            </li>


                        </ul>
                    </div>


                </div>

            </div>
        </div>

        <section className='wraper'>
            <div className='box_shadow mt-14'>
                <div className='row'>
                    {/* <div className='col-md-12'>
                        <h3 className='headings'>Authorized Signatory Details</h3>
                    </div> */}
                    <div className='col-lg-4 text-center'>
                        <div class="complny_log">
                            <a className='clickUpload'><i className='fa fa-camera'></i></a>
                            <figure>
                                <a title="" href="#">
                                    <img alt="" src="/assets/images/Fernanda.png" />
                                </a>
                            </figure>
                        </div>
                        <p className='Users'>(Service Manager)</p>


                    </div>
                    <div className='col-md-8'>
                         <div className='text_click text-end'>
                           <a href='/my-profile/personal-information'> <i className='fa fa-edit'></i></a>
                           </div>
                        <div class="d-flex mb-3">
                            <div class="labl">Full Name </div>
                            <div class="labl_detls">Mr. Rahul Singh</div>
                        </div>
                        <div class="d-flex mb-3">
                            <div class="labl">Phone Number </div>
                            <div class="labl_detls">9716983756</div>
                        </div>

                        <div class="d-flex mb-3">
                            <div class="labl">Business Email ID </div>
                            <div class="labl_detls">tech@gmail.com</div>
                        </div>


                        <div class="d-flex mb-3">
                            <div class="labl">Nationality </div>
                            <div class="labl_detls">Indian</div>
                        </div>

                        <div class="d-flex mb-3">
                            <div class="labl">User Language </div>
                            <div class="labl_detls">English</div>
                        </div>
                        

                    </div>

                </div>
            </div>



        </section>

    </>
);

export default Myprofile;